import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function GoaDeluxe() {
    const heading = "Deluxe Room";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Goa Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-goa/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Deluxe Room",
            },
        ]
    }

    const roomBanner = {
        image: "/image/goa-deluxe-room-detail.webp",
    };

    const roomQuote = {
        content: "The Deluxe Room is designed for those who want a bit more breathing room without losing that intimate, cozy feel. It’s bright, airy, and features premium pocketed spring mattresses that make sleeping in the best part of your vacation. It’s the ideal spot to kick back after a day of Vitamin Sea.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "King",
        area: "24",
        bathroom: "1",
        guest: "2",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/goa-deluxe-room-gallery-1.webp" },
        { image: "/image/goa-deluxe-room-gallery-2.webp" },
        { image: "/image/goa-deluxe-room-gallery-3.webp" },
        { image: "/image/goa-deluxe-room-gallery-4.webp" },
        { image: "/image/goa-deluxe-room-gallery-5.webp" },
        // { image: "/image/goa-deluxe-room-gallery-6.webp" },
    ];

    const roomEquipment = {
        description: "Unwind in a comfortable setting featuring modern conveniences and carefully considered details for a seamless stay.",
        equipment: [
        [
            "Hydropneumatic Pressure Shower",
            "Pocketed Spring Mattress for deep sleep",
            "Plush Cotton Linens & Soft Duvet",
            "Turndown Service every evening (on request)",
        ],
        [
            "Mini-Fridge for your snacks and beverages",
            "Tea and Coffee brewing station",
            "Large LED Screen with Satellite channels",
            "Fast & Complimentary Wi-Fi",
        ],
        [
            "Makeup Mirror & Hair Dryer",
            "Bidet and modern bath fittings",
            "Safety Locker for peace of mind",
            "24-Hour Room Service access",
            "Speaker Phone with one-touch hospitality keys",
        ]
    ]
    };

    const roomBook = {
        location: "Goa",
        title: "Deluxe Room",
        desc: "Relax in the thoughtfully designed Deluxe Room at De Coracao Goa, offering extra space, modern comforts, and a calm, inviting atmosphere. With a plush king bed and premium amenities, it is an ideal retreat after a day spent discovering Goa.",
        details: [
            "1 King Size Bed",
            "2 Guests",
            "24 sq mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y"
    };


    const otherRoom = {
        slides: [
            {
                title: 'Premium Room',
                 bg: '/image/goa-other-room-1.webp',
                slug: '/resort-de-coracao-goa/premium-room',
                details: [
                    "1 King Bed + 1 Extra Mattress ",
                    "Up to 3 Guests",
                    "30 sq mt",
                ],
            },

            {
                title: 'Super Deluxe Room',
                bg: '/image/goa-other-room-2.webp',
                slug: '/resort-de-coracao-goa/super-deluxe-room',
                details: [
                    "1 King Size Bed + 1 Extra Mattress ",
                    "Up to 3 Guests",
                    "28 sq mt",
                ],
            },

            {
                title: 'Suite Room',
                bg: '/image/goa-other-room-3.webp',
                slug: '/resort-de-coracao-goa/suite-room',
                details: [
                    "1 King Size Bed + Living Room Seating",
                    "3 Guests",
                    "37 sq.mt.",
                ],
            },

            {
                title: 'Standard Room',
                bg: '/image/goa-other-room-6.webp',
                slug: '/resort-de-coracao-goa/standard-room',
                details: [
                    "1 King Size Bed",
                    "2 Guests",
                    " 21 sq. mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-goa/room-listing" }
    }

    return (
        <>  
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
